import { createContext } from 'react';

export const gridSpacing = 2;

export const ChatContext = createContext({});
